import styled from "@emotion/styled";
import "./Collage.css";
import Vector1 from "./images/Vector1.png";
import Mural from "./images/Background.jpg";
import useSound from "use-sound";
import song from "./audio/autotomia–tumannyy.mp3";
import { useState } from "react";
import Logo from "./images/logo512.png";

const StyledApp = styled.div`
  left: 0;
  top: 0;
  height: 24381px;
  width: 1440px;
  header {
    position: fixed;
    z-index: 200;
    top: 1rem;
    right: 1rem;
    mix-blend-mode:invert;
    z-index: 100;
    transition: all 2s ease-out;
    filter: invert(100%);
    &:hover {

      transform: scale(2) translateX(-100px) translateY(0); 
    }
    .Logo {
      width: 100px;
    }
    button {
      font-size: 4rem;
    font-weight: bold;
    text-transform: uppercase;
    border: 5px solid black;
    border-bottom: none;
    background: transparent;
    border-right: none;
    }
  }
  .Mural {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 0;
  }
`;

const StyledLayer = styled.div`
  height: 24381px;
  width: 1440px;
  height: 24381px;
  width: 1440px;
  cursor: pointer;
`;

const Layer = ({ children }) => {
  return <StyledLayer>{children}</StyledLayer>;
};

const Images = () => {
  return (
    <StyledLayer>
      {" "}
      <div className="Image Image1" />
      <div className="Image Image2" />
      <div className="Image Image3" />
      <div className="Image Image5" />
      <div className="Image Image4" />
      <div className="Image Image6" />
      <div className="Image Image7" />
      <div className="Image Image8" />
      <div className="Image Image9" />
      <div className="Image Image10" />
      <div className="Image Image11" />
      <div className="Image Image12" />
      <div className="Image Image13" />
      <div className="Image Image14" />
      <div className="Image Image15" />
      <div className="Image Image16" />
      <div className="Image Image17" />
      <div className="Image Image18" />
      <div className="Image Image19" />
      <div className="Image Image20" />
      <div className="Image Image21" />
      <div className="Image Image22" />
      <div className="Image Image23" />
      <div className="Image Image24" />
      <div className="Image Image25" />
      <div className="Image Image26" />
      <div className="Image Image27" />
      <div className="Image Image29" />
      <div className="Image Image30" />
      <div className="Image Image31" />
      <div className="Image Image32" />
      <div className="Image Image33" />
      <div className="Image Image34" />
      <div className="Image Image35" />
      <div className="Image Image36" />
      <div className="Image Image37" />
      <div className="Image Image38" />
      <div className="Image Image39" />
      <div className="Image Image40" />
      <div className="Image Image41" />
      <div className="Image Image42" />
      <div className="Image Image43" />
      <div className="Image Image44" />
      <div className="Image Image45" />
      <div className="Image Image46" />
      <div className="Image Image47" />
      <div className="Image Image48" />
      <div className="Image Image49" />
      <div className="Image Image50" />
      <div className="Image Image51" />
      <div className="Image Image52" />
      <div className="Image Image53" />
      <div className="Image Image54" />
      <div className="Image Image55" />
      <div className="Image Image56" />
      <div className="Image Image57" />
      <div className="Image Image58" />
      <div className="Image Image59" />
      <div className="Image Image60" />
      <div className="Image Image61" />
      <div className="Image Image62" />
      <div className="Image Image63" />
      <div className="Image Image64" />
      <div className="Image Image65" />
      <div className="Image Image66" />
      <div className="Image Image67" />
      <div className="Image Image68" />
      <div className="Image Image69" />
      <div className="Image Image70" />
      <div className="Image Image71" />
      <div className="Image Image72" />
      <div className="Image Image73" />
      <div className="Image Image74" />
      <div className="Image Image75" />
      <div className="Image Image76" />
    </StyledLayer>
  );
};

function Collage() {
  const [play, { stop, isPlaying, duration, sound }] = useSound(song, {
    volume: 1,
  });
  // const [playOn] = useSound("/audio/switch-off.mp3", { volume: 0.25 });

  const [isLoading, setIsLoading] = useState(true);

  return (
    <StyledApp>
      {/* <FullControl /> */}
      <header>
        
        

        {!isPlaying && <button onClick={play}><img className="Logo" src={Logo} alt="" /></button>}
        {isPlaying && (
          <>
            Playing: <br />Tumannyy<br />
            <img className="Vector1" src={Vector1} alt="" />
          </>
        )}
        {/* <img src="/images/Vector2.png" />
        <img src="/images/Vector3.png" />
      <img src="/images/Vector4.png" /> */}
      </header>
      <Layer onClick={play}>
        <img className="Mural" src={Mural} alt="" />
        <Images/>
      </Layer>
    </StyledApp>
  );
}

export default Collage;

// Ich entziehe mich deiner Anziehungskraft.
// Foggy ich sehne mich nach deiner Anziehungskraft
// Do you know what they did at the WBA?
// We invested in America.
// People are all twisted freaks.
// Der Traum ist hin.
// Der neue gott ist das internet
// Und auch dieser gott wird sterblich sein
// Das es jemanden gibt der unsere Probleme lösst.
